import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { API, axios } from '../utils/api';
import { COLLABORAZIONI, DICHIARAZIONI } from '../utils/scheda';
import Icona from '../components/cliente/Icone';
import { Logo } from './staff/Agenzie';
import '../components/staff/scheda.css';
import '../components/staff/impostazioni.css';

// /admin/agenzie/:id/modifica (Modifica dalla scheda agenzia), nello stile delle pagine dello staff: logo (caricato,
// trascinato o da un link; si può togliere), nome, marchio, contatto, telefono, email, sito, comune e indirizzo (con la
// posizione per la mappa), collaborazione, dichiarazione, note interne. PUT /agenzie/{id} ricalcola marchio ed etichetta.

const TIPI_LOGO = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/svg+xml'];
const VUOTO = { nome: '', marchio: '', contatto: '', telefono: '', email: '', sito_web: '', comune: '', indirizzo: '',
  stato_verifica: 'in_attesa', stato_dichiarato: 'in_attesa_dichiarazione', note_admin: '', logo_url: '' };
const errore = (e, riserva) => toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : riserva);

export const MAX_NOME_AGENZIA = 200;   // backend/agenzie_identita.py, MAX_NOME

const ModificaAgenzia = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dati, setDati] = useState(null);
  const [salva, setSalva] = useState(false);
  const [carica, setCarica] = useState(false);
  const [sopra, setSopra] = useState(false);
  const input = useRef(null);

  useEffect(() => {
    axios.get(`${API}/agenzie/${id}`).then((r) => {
      const a = r.data.agenzia || {};
      setDati(Object.fromEntries(Object.keys(VUOTO).map((k) => [k, k === 'comune' ? (a.sede?.comune || a.comune || '') : k === 'indirizzo' ? (a.sede?.indirizzo || a.indirizzo || '') : (a[k] ?? VUOTO[k])])));
    }).catch(() => setDati(false));
  }, [id]);

  const caricaLogo = async (file) => {
    if (!file) return;
    if (!TIPI_LOGO.includes(file.type)) { toast.error('Formato non supportato: JPG, PNG, WEBP, GIF o SVG'); return; }
    if (file.size > 10 * 1024 * 1024) { toast.error('File troppo grande (massimo 10 MB)'); return; }
    setCarica(true);
    try {
      const modulo = new FormData();
      modulo.append('file', file);
      const r = await axios.post(`${API}/agenzie/${id}/upload-logo`, modulo, { headers: { 'Content-Type': 'multipart/form-data' } });
      setDati((d) => ({ ...d, logo_url: r.data.logo_url }));
      toast.success('Logo caricato');
    } catch (e) { errore(e, 'Logo non caricato'); } finally { setCarica(false); }
  };
  const togliLogo = async () => {
    try { await axios.put(`${API}/agenzie/${id}`, { logo_url: '' }); setDati((d) => ({ ...d, logo_url: '' })); toast.success('Logo tolto'); } catch (e) { errore(e, 'Logo non tolto'); }
  };

  const invia = async (e) => {
    e.preventDefault();
    if (!dati.nome.trim()) { toast.error("Il nome dell'agenzia serve"); return; }
    setSalva(true);
    try {
      const corpo = { ...dati, marchio: dati.marchio.trim() || null, si_puo_lavorare: dati.stato_verifica !== 'non_lavorabile' };
      if (dati.comune.trim()) {
        try {
          const g = await axios.get(`${API}/geocode`, { params: { q: dati.comune } });
          if (g.data?.lat) { corpo.latitudine = g.data.lat; corpo.longitudine = g.data.lon; }
        } catch { /* senza posizione */ }
      }
      await axios.put(`${API}/agenzie/${id}`, corpo);
      toast.success('Agenzia aggiornata');
      navigate(`/admin/agenzie/${id}`);
    } catch (err) { errore(err, 'Agenzia non aggiornata'); setSalva(false); }
  };

  if (dati === false) return <main className="st wrap"><p className="vuoto">Agenzia non trovata.</p></main>;
  if (!dati) return <main className="st wrap"><p className="vuoto">Carico l'agenzia…</p></main>;
  const campo = (k, testo, props = {}) => <label className={props.largo ? 'largo' : undefined}>{testo}<input value={dati[k]} onChange={(e) => setDati({ ...dati, [k]: e.target.value })} {...{ ...props, largo: undefined }} /></label>;
  const scelte = (k, elenco, etichetta) => (
    <div className="imp-campo" role="group" aria-label={etichetta}>{etichetta}
      <div className="imp-azioni" style={{ marginTop: '.2rem' }}>
        {Object.entries(elenco).map(([v, d]) => (
          <button type="button" key={v} className={`chip${dati[k] === v ? ' on' : ''}`} aria-pressed={dati[k] === v} onClick={() => setDati({ ...dati, [k]: v })}>
            {d.colore && <i style={{ background: d.colore }} />}{d.testo}
          </button>
        ))}
      </div>
    </div>
  );
  return (
    <main className="st wrap" data-testid="modifica-agenzia" style={{ maxWidth: 900 }}>
      <Link className="back" to={`/admin/agenzie/${id}`}><Icona nome="indietro" />Scheda dell'agenzia</Link>
      <div className="imp-head"><div><div className="k">Agenzie</div><h1>Modifica · <em>{dati.nome || 'agenzia'}</em></h1></div></div>
      <form className="imp-griglia" onSubmit={invia}>
        <section className="card">
          <div className="ttl"><div className="i"><Icona nome="edificio" /></div><h2>Logo</h2></div>
          <div className={`logo-carica${sopra ? ' sopra' : ''}`} data-testid="logo-carica"
            onDragOver={(e) => { e.preventDefault(); setSopra(true); }} onDragLeave={() => setSopra(false)}
            onDrop={(e) => { e.preventDefault(); setSopra(false); caricaLogo(e.dataTransfer.files?.[0]); }}>
            <Logo a={{ nome: dati.nome, logo_url: dati.logo_url }} />
            <div style={{ minWidth: 0, flex: 1 }}>
              <p className="imp-nota">Trascinate qui l'immagine o sceglietela (JPG, PNG, WEBP, GIF o SVG, fino a 10 MB). Va su R2 come le foto.</p>
              <div className="imp-azioni">
                <button type="button" className="btn sm" disabled={carica} onClick={() => input.current?.click()}>{carica ? 'Carico…' : 'Scegli il file'}</button>
                {dati.logo_url && <button type="button" className="btn sm rosso-vuoto" onClick={togliLogo}>Togli il logo</button>}
              </div>
              <input ref={input} type="file" accept={TIPI_LOGO.join(',')} hidden onChange={(e) => { caricaLogo(e.target.files?.[0]); e.target.value = ''; }} aria-label="File del logo" />
            </div>
          </div>
          <div className="imp-campi" style={{ marginTop: '.8rem' }}>{campo('logo_url', 'Oppure il link del logo', { largo: true, placeholder: 'https://…' })}</div>
        </section>
        <section className="card">
          <div className="ttl"><div className="i b"><Icona nome="profilo" /></div><h2>Dati</h2></div>
          <div className="imp-campi">
            {/* il tetto di sicurezza del server (backend/agenzie_identita.py, MAX_NOME): la casella si ferma lì,
                e il nome NON si taglia mai al salvataggio — nelle liste si accorcia solo a video */}
            {campo('nome', 'Nome *', { required: true, maxLength: MAX_NOME_AGENZIA })}
            {campo('marchio', 'Marchio (vuoto = indipendente)', { placeholder: 'es. Tecnocasa' })}
            {campo('contatto', 'Contatto')}
            {campo('telefono', 'Telefono', { inputMode: 'tel' })}
            {campo('email', 'Email', { type: 'email' })}
            {campo('sito_web', 'Sito web', { placeholder: 'https://…' })}
            {campo('comune', 'Comune')}
            {campo('indirizzo', 'Indirizzo')}
          </div>
        </section>
        <section className="card">
          <div className="ttl"><div className="i g"><Icona nome="si" /></div><h2>Collaborazione e dichiarazione</h2></div>
          <div className="imp-griglia">
            {scelte('stato_verifica', COLLABORAZIONI, 'Collaborazione')}
            {scelte('stato_dichiarato', DICHIARAZIONI, 'Dichiarazione')}
          </div>
        </section>
        <section className="card">
          <div className="ttl"><div className="i"><Icona nome="documento" /></div><h2>Note interne</h2><span className="tag t-b">solo per noi</span></div>
          <div className="imp-campi"><label className="largo">Tutte le note (una per riga: quelle aggiunte dalla scheda hanno data e autore)
            <textarea rows={6} value={dati.note_admin} onChange={(e) => setDati({ ...dati, note_admin: e.target.value })} /></label></div>
        </section>
        <div className="imp-azioni">
          <button type="submit" className="btn p" disabled={salva}>{salva ? 'Salvo…' : 'Salva'}</button>
          <Link className="btn" to={`/admin/agenzie/${id}`}>Annulla</Link>
        </div>
      </form>
    </main>
  );
};

export default ModificaAgenzia;
